<template>
    <div class="additional-documents">
        <div class="additional-documents-container">
            <div class="add-documents position-relative">
                <label class="button button-m button-primary add-file" @click="checkMaxUpload($event)" :class="{disabled: maxUploadReached}">
                    {{ $t('components.additional_documents.upload_a_file') }}
                    <input type="file" accept=".txt,.pdf,.xls,.xlsx,.zip,.csv,.doc,.docx" class="button button-m button-primary" @change="uploadFile($event.target.files[0]);">
                </label>
                
                <p class="subtitle text-secondary">{{ $t('components.additional_documents.or') }}</p>
                <button :class="{disabled: maxUploadReached}" class="button button-m button-primary" @click.prevent="insertLink()">{{ $t('components.additional_documents.insert_a_link') }}</button>

                <span v-if="maxUploadReached" class="add-documents__max_filesize text-secondary">Maximum amount of files uploaded (5)</span>
            </div>
            <template v-if="documents.length">
                <div class="added-documents">
                    <p class="subtitle text-secondary">{{ $t('components.additional_documents.added_documents') }}</p>

                    <div class="added-documents__list">
                        <div class="added-document" v-for="doc in documents" :key="doc.id">
                            <div class="added-document__info">
                                <img :src="getImage(doc.extension)" alt="">
                                <div class="added-document__info__text">
                                    <p class="subtitle">{{ doc.name }}</p>
                                    <template v-if="doc.type === 'link'">
                                        <p class="text-secondary">{{ doc.file_path }}</p>
                                    </template>
                                    <template v-else>
                                        <p class="text-secondary">{{ getType(doc.extension) }}, {{ getFileSize(doc.filesize) }}</p>
                                    </template>
                                </div>
                            </div>
                            <button class="button button-m button-outline button-outline__primary-blue" @click.prevent="edit(doc)">{{ $t('components.additional_documents.edit') }}</button>
                            <button class="button button-m button-outline button-outline__danger" @click.prevent="remove(doc)">{{ $t('components.additional_documents.remove') }}</button>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <template v-if="insert_link">
            <div class="additional-documents__add">
                <div class="embed-video-overlay">
                    <div class="embed-video-container">
                        <div class="embed-video-container__header">
                            <h5 class="position-relative">{{ $t('components.additional_documents.insert_a_link') }}</h5>
                        </div>
                        <div class="embed-video-container__body">
                            <div class="input-group">
                                <input type="text" name="title" :placeholder="$t('components.additional_documents.link_url_placeholder')" class="input" v-model="new_document.link"> <label for="title" class="subtitle text-primary">{{ $t('components.additional_documents.link_url') }}</label>
                            </div>
                            <div class="input-group">
                                <input type="text" name="title" :placeholder="$t('components.additional_documents.link_text_placeholder')" class="input" v-model="new_document.name"> <label for="title" class="subtitle text-primary">{{ $t('components.additional_documents.link_text') }}</label>
                            </div>
                        </div>
                        <div class="embed-video-container__footer d-flex">
                            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="cancel()">{{ $t('components.additional_documents.cancel') }}</button> <button :disabled="createDisabled" class="button button-m button-primary" @click.prevent="saveLink()">{{ $t('components.additional_documents.insert_link') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="update_document">
            <div class="additional-documents__add">
                <div class="embed-video-overlay">
                    <div class="embed-video-container">
                        <div class="embed-video-container__header">
                            <h5 v-if="edit_document.type == 'link'" class="position-relative">{{ $t('components.additional_documents.update_a_link') }}</h5>
                            <h5 v-else class="position-relative">{{ $t('components.additional_documents.change_file_title') }}</h5>
                        </div>
                        <div class="embed-video-container__body">
                            <template v-if="edit_document.type === 'link'">
                                <div class="input-group">
                                    <input type="text" name="title" :placeholder="$t('components.additional_documents.link_url_placeholder')" class="input" v-model="edit_document.link"> <label for="title" class="subtitle text-primary">{{ $t('components.additional_documents.link_url') }}</label>
                                </div>
                            </template>
                            <div class="input-group">
                                <input type="text" name="title" :placeholder="$t('components.additional_documents.link_text_placeholder')" class="input" v-model="edit_document.name"> <label for="title" class="subtitle text-primary">
                                    <template v-if="edit_document.type == 'link'">{{ $t('components.additional_documents.link_text') }}</template>
                                    <template v-else>{{ $t('components.additional_documents.file_title') }}</template>
                                </label>
                            </div>
                        </div>
                        <div class="embed-video-container__footer d-flex">
                            <button class="ml-auto button button-m button-secondary mr-16" @click.prevent="cancel()">{{ $t('components.additional_documents.cancel') }}</button> <button :disabled="updateDisabled" class="button button-m button-primary" @click.prevent="updateDocument()">{{ $t('components.additional_documents.update') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>    
        <confirmation-popup-inner ref="confirm"
            :button_text="$t('components.additional_documents.remove')"
            @confirmed="confirmRemove"
        ></confirmation-popup-inner>
    </div>
</template>

<script>
    export default {
        props: {
            listing_id: {
                default: null,
                type: Number
            }
        },
        mounted() {
            this.getDocuments();
        },
        computed: {
            maxUploadReached() {
                return this.documents.length >= 5 ? true : false;
            },
            createDisabled() {
                return !this.new_document.link || !this.new_document.name ? true : false;
            },
            updateDisabled() {
                return !this.edit_document.link || !this.edit_document.name ? true : false;
            }
        },
        data() {
            return {
                insert_link: false,
                update_document: false,
                new_document: {
                    link: "",
                    name: ""
                },
                edit_document: {
                    link: "",
                    name: "",
                    type: null,
                    id: null
                },
                documents: [],
            }
        },
        methods: {
            getDocuments() {
                const url = `/api/listing/${this.listing_id}/documents`;

                return axios.get(url).then(response => {
                    this.documents = response.data.data.additional_documents;
                }).catch(error => {
                    
                });
            },
            insertLink() {
                if (this.documents.length >= 5) {
                    this.notifyMaxUploadReached();
                    return;
                }

                this.insert_link = true;
            },
            cancel() {
                this.insert_link = false;
                this.new_document = {
                    link: "",
                    name: ""
                };
                this.update_document = false;
            },
            saveLink() {
                const url = `/api/listing/${this.listing_id}/documents/add-link`;

                return axios.post(url, this.new_document).then(response => {
                    this.documents.push(response.data.data.additional_document);

                    this.cancel();
                }).catch(error => {
                    this.$toastr.error('Not a valid link');
                });
            },
            remove(doc) {
                let title = doc.type == 'file' 
                    ? this.$t('components.additional_documents.delete_file_title')
                    : this.$t('components.additional_documents.delete_link_title');

                let description = doc.type == 'file'
                    ? this.$t('components.additional_documents.delete_file_description')
                    : this.$t('components.additional_documents.delete_link_description');

                this.$refs.confirm.setTitle(title);
                this.$refs.confirm.setDescription(description);
                this.$refs.confirm.showConfirm(doc)
            },
            confirmRemove(doc) {
                const url = `/api/listing/${this.listing_id}/documents/${doc.id}`;

                return axios.delete(url).then(response => {
                    this.documents.splice(this.documents.findIndex(item => item.id === doc.id), 1);
                }).catch(error => {
                });
            },
            edit(doc) {
                this.update_document = true;
                this.edit_document.link = doc.file_path;
                this.edit_document.type = doc.type;
                this.edit_document.id = doc.id;
                this.edit_document.name = doc.name;
            },
            updateDocument() {
                const url = `/api/listing/${this.listing_id}/documents/${this.edit_document.id}`;
                let updated_data = {
                    name: this.edit_document.name,
                }

                if (this.edit_document.type == 'link') {
                    updated_data.link = this.edit_document.link;
                }

                return axios.patch(url, updated_data)
                .then(response => {
                    let index = this.documents.findIndex(item => item.id === this.edit_document.id);

                    this.documents[index] = response.data.data.additional_document;
                    this.cancel();
                }).catch(error => {
                    this.$toastr.error('Not a valid link');
                });
            },
            uploadFile(file) {
                let filesize = file.size / 1048576;

                if (filesize >= 10) {
                    this.$toastr.error('File is too large.');

                    return;
                }

                const url = `/api/listing/${this.listing_id}/documents/add-file`;
                const formData = new FormData();

                formData.append('additional_document', file, file.name);

                return axios.post(url, formData)
                    // get data
                    .then(function (response) {
                        this.documents.push(response.data.data.additional_document);
                        
                        this.$toastr.success('File uploaded');
                    }.bind(this)).catch(error => {
                        this.$toastr.error('Failed to upload - max file size is 10MB.');
                    });
            },
            getImage(extension) {
                if (!extension) {
                    return `/img/icons/link.svg`;
                }

                return `/img/icons/${extension}.svg`;
            },
            getType(extension) {
                return extension.toUpperCase();
            },
            getFileSize(filesize) {
                const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                let l = 0, n = parseInt(filesize, 10) || 0;

                while(n >= 1024 && ++l){
                    n = n/1024;
                }
                //include a decimal point and a tenths-place digit if presenting 
                //less than ten of KB or greater units
                return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
            },
            notifyMaxUploadReached() {
                return this.$toastr.error('Maximum amount of files uploaded (5)');
            },
            checkMaxUpload(e) {
                if (this.documents.length >= 5) {
                    e.preventDefault();
                    this.notifyMaxUploadReached();
                }
            }
        },
        watch: {
        }
    }
</script>
